export default import.meta.ROLLDOWN_FILE_URL_2seC8DgtsO0ucggS_u9_sQ